// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AuditTrailHelper  {
    _originalTypeClassName = "Loom.BO.AuditTrailHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AuditTrailHelper.translate = translateService;
}
this.AuditTrailHelperKey = null;
this._key = this.AuditTrailHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _AuditTrailHelperKey:any;
get AuditTrailHelperKey(): any {
    return this._AuditTrailHelperKey;
  }
set AuditTrailHelperKey(value: any) {
    this._AuditTrailHelperKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AuditTrailHelperKey == null || $this.AuditTrailHelperKey == 0;
            }


}